module.exports = __webpack_public_path__ + "img/sdg6.b3f0a883.svg";